import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { setToken } from "@/lib/api";
import Orb from "@/components/Orb";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogleSession, refresh } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";

    // Microsoft SSO: backend redirected with a ready-to-use app JWT in the hash.
    const ms = hash.match(/ms_token=([^&]+)/);
    if (ms) {
      const token = decodeURIComponent(ms[1]);
      (async () => {
        try {
          setToken(token);
          await refresh();
          window.history.replaceState(null, "", window.location.pathname);
          navigate("/chat", { replace: true });
        } catch (e) {
          toast.error("Couldn't complete Microsoft sign-in.");
          navigate("/login", { replace: true });
        }
      })();
      return;
    }

    // Emergent Google: exchange the one-time session_id.
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await loginWithGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/chat", { replace: true });
      } catch (e) {
        toast.error("Couldn't complete Google sign-in.");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, refresh, navigate]);

  return (
    <div className="ph-shell" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 18 }}>
      <Orb size={84} state="thinking" />
      <div className="text-dim" style={{ fontSize: 13 }}>Signing you in…</div>
    </div>
  );
}
